import { render, staticRenderFns } from "./LiefengEditor.vue?vue&type=template&id=0f7facc7&scoped=true&"
import script from "./LiefengEditor.vue?vue&type=script&lang=js&"
export * from "./LiefengEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7facc7",
  null
  
)

export default component.exports